//import cimg1 from '../images/causes/Financial Aid-Education.png'
import cimg1 from '../images/causes/financialSupport.jpg'
import cimg2 from '../images/causes/Financial Aid-Education (2).png'
import cimg3 from '../images/causes/Empower Young Adults (2).png'
import eimg4 from '../images/causes/Domestic Violence Survivor.png'
import eimg5 from '../images/causes/Overcome Divorce Challenges.png'

const Causes = [
    {
        id: '1',
        cImg:cimg1,
        process:'65',
        thumb:'Financial Aid for Students',
        cTitle: 'Donate in Support Education for All Students.',
        slug:'Childrens-voices', 
        Goal:'3,000.00',
        Raised:'2,000.00',
        authorName:'Laura Faiary',
    },
    {
        id: '2',
        cImg:cimg2,
        process:'75',
        thumb:'Academic Resources and Guidance ',
        cTitle: 'Help Us Provide Academic Resources and Guidance for Students in Need.',
        slug:'African-Kids',
        Goal:'3,000.00',
        Raised:'2,000.00',
        authorName:'Laura Faiary',
    },
    {
        id: '3',
        cImg:cimg3,
        process:'85',
        thumb:'Mentorship for Young Adult',
        cTitle: 'Donate to Empower Young Adults through Mentorship and Development.',
        slug:'Human-Life',
        Goal:'3,000.00',
        Raised:'2,000.00',
        authorName:'Laura Faiary',
    },
    {
        id: '4',
        cImg:eimg4,
        process:'95',
        thumb:'Hope & Healing after A Life Transition',
        cTitle: 'Contribute to Support Women Survivors of Intimate Partner Violence',
        slug:'Give-African-Child-A-Good-Education',
        Goal:'3,000.00',
        Raised:'2,000.00',
        authorName:'Laura Faiary',
    }
]

export default Causes;